module.exports = __webpack_public_path__ + "static/img/copyright-c.693bfb14.png";